// Environment variables with fallbacks
export const RPC_URL = process.env.REACT_APP_RPC_URL || 'https://mainnet.base.org';
export const PRESALE_WALLET_ADDRESS = process.env.REACT_APP_PRESALE_WALLET_ADDRESS || '0xD2c65B4C84c871fed372991c127F6b21C021b999';
export const MAX_CONTRIBUTION = parseFloat(process.env.REACT_APP_MAX_CONTRIBUTION || '0.1');
export const MIN_CONTRIBUTION = parseFloat(process.env.REACT_APP_MIN_CONTRIBUTION || '0.01');
export const SOFT_CAP_ETH = parseFloat(process.env.REACT_APP_SOFT_CAP || '2');

// Refresh intervals - less frequent to avoid rate limits
export const BALANCE_REFRESH_INTERVAL = 30000; // 30 seconds
export const PRICE_REFRESH_INTERVAL = 60000;  // 60 seconds (once per minute)
export const REFRESH_INTERVAL = 30000; // Kept for backward compatibility

// API endpoints
export const COINGECKO_API_BASE = 'https://api.coingecko.com/api/v3';
export const ETH_PRICE_ENDPOINT = `${COINGECKO_API_BASE}/simple/price?ids=ethereum&vs_currencies=usd`;

// Chart colors
export const CHART_COLORS = {
  liquidity: '#c41e3a',     // Yakuza Red
  presale: '#d4af37',       // Gold
  marketing: '#f8f0e3',     // Paper white
  team: '#333333',          // Dark gray
  treasury: '#666666',      // Light gray
};

// Token multipliers (for display purposes)
export const MILLION = 1000000;
export const BILLION = 1000000000;

// Formatting options
export const USD_FORMAT_OPTIONS = {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
};

export const ETH_FORMAT_OPTIONS = {
  maximumFractionDigits: 4,
};

export const PERCENTAGE_FORMAT_OPTIONS = {
  style: 'percent',
  maximumFractionDigits: 2,
};

// Network details
export const NETWORK = {
  name: 'Base',
  chainId: 8453,
  blockExplorerUrl: 'https://basescan.org',
};